export default "<div [ngClass]=\"{ container: upperMarginNeeded }\">\n  <div class=\"loader\">Loading...</div>\n</div>\n"